<template>
  <div class="packages-container">
    <h1>Packages</h1>
    <div class="current-subscription" v-if="subscription && !showPackages">
      <div>
        <div class="sub-item">
          <p>Your plan</p>
          <section>
            <div class="main-text">Premium, {{ subscription.period }} subscription</div>
            <div class="side-text">
              {{ subscription.amount }} {{ subscription.currency }}
              <span>/{{ subscription.period === 'monthly' ? 'month' : 'year' }}</span>
            </div>
          </section>
        </div>

        <div class="sub-item" v-if="isKnet">
          <p>Transaction id</p>
          <section>
            <div class="side-text">{{ subscription.tranid }}</div>
          </section>
        </div>

        <div class="sub-item" v-if="isKnet">
          <p>Payment id</p>
          <section>
            <div class="main-text">{{ subscription.paymentid }}</div>
          </section>
        </div>

        <div class="sub-item" v-if="isKnet">
          <p>Payment Date</p>
          <section>
            <div class="main-text">{{ subscription.paymentDate }}</div>
          </section>
        </div>

        <div class="sub-item">
          <p>Subscription term</p>
          <section>
            <template v-if="subscription.expiredAt">
              <div class="main-text">Your subscription expired at</div>
            </template>
            <template v-else>
              <div class="main-text">Your subscription will renew on</div>
            </template>
            <div class="side-text">{{  subscription.nextRenewAt }}</div>
          </section>
        </div>
      </div>
      <div class="cancel-subscription">
        <template v-if="subscription && !subscription.hasOwnProperty('expiredAt')">
          <a href=""
             class="blue-link"
             @click.prevent="cancelSubscription()">Click here to cancel</a>
        </template>
      </div>
    </div>
    <div class="no-packages" v-if="showPackages && !knet.error">
      <p>You have no connected package.</p>
      <p>Choose a package to use more features.</p>

      <div class="chose-package" >
        <router-link to="/account/subscription/payment" class="btn btn-blue">
          Choose package
        </router-link>
      </div>
    </div>

    <div class="error" v-if="knet.error">
      <p class="message">Error: {{ knet.error }}</p>
      <p>Payment id: {{ knet.paymentid }}</p>
      <p>Transaction id: {{ knet.tranid }}</p>
      <p>Amount: {{ knet.amount }} {{ knet.currency }}</p>
      <p>Date: {{ knet.date }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store';
import { isTodayGreaterCompared } from '../../../helpers/date';

export default {
  name: 'Subscription',
  async beforeRouteEnter(to, from, next) {
    if (to.query.source === 'knet' && to.query.status === 'success') {
      const { message, data } = await store.dispatch('payment/createKNETPayment', to.query.data);

      if (message) {
        next((vm) => {
          vm.showErrorMessage(message);
        });
      } else {
        next((vm) => {
          vm.initKnet(data.result);
        });
      }
    } else if (to.query.token && ['sms_pin', 'header_enrichment_pin'].includes(to.query.auth_method)) {
      const { message, data } = await store.dispatch('payment/createSlaSubscription', { token: to.query.token, service: to.params.service });
      if (message) {
        next((vm) => {
          vm.showErrorMessage(message);
        });
      } else {
        next((vm) => {
          vm.initSLA(data.result);
        });
      }
    } else if (to.query.errorText) {
      next((vm) => {
        vm.showErrorMessage(to.query.errorText);
      });
    } else next();
    await store.dispatch('payment/getSubscription');
  },
  data: () => ({
    knet: {
      error: false,
      paymentid: null,
      amount: null,
      date: null,
    },
  }),
  computed: {
    ...mapState('payment', ['subscription']),
    isKnet() {
      return this.subscription.source === 'knet';
    },
    showPackages() {
      if (this.subscription?.expiredAt) {
        return isTodayGreaterCompared(this.subscription.expiredAt);
      }

      return !this.subscription;
    },
  },
  methods: {
    async cancelSubscription() {
      const confirm = await this.$swal({
        title: 'Cancel subscription?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      });

      if (confirm.value) {
        await this.$store.dispatch('payment/cancelSubscription');
        await store.dispatch('payment/getSubscription');
        this.$toasted.show('Subscription canceled');
      }
    },
    showErrorMessage(message) {
      this.$toasted.error(message, { duration: 5000 });
    },
    initKnet(data) {
      const { message, error } = data;
      if (message) this.showErrorMessage(message);
      if (error) this.knet = { ...data };

      this.$router.replace(this.$route.path);
    },
    initSLA() {
      this.$router.replace(this.$route.path);
    },
  },
};
</script>

<style lang="less" scoped>
  .packages-container {
    h1 {
      margin: 0;
    }

    .no-packages {
      p + p {
        color: #4d4d4d;
      }

      .chose-package {
        margin-top: 32px;
        text-align: center;
      }
    }

    .current-subscription {
      .sub-item {
        margin-top: 30px;

        p {
          color: rgba(221, 221, 221, 0.8);
          margin: 0 0 10px;
        }

        section {
          display: flex;
          background-color: #333;
          justify-content: space-between;
          align-items: center;
          border-radius: 5px;
          padding: 13px;

          .side-text span {
            color: rgba(221, 221, 221, 0.5);
          }
        }
      }

      .cancel-subscription {
        margin-top: 60px;
      }
    }

    .error {
      .message {
        color: #ff0000;
      }
    }
  }

  @media (max-width: 768px) {
    .packages-container {
      .current-subscription {
        .sub-item {
          section {
            flex-direction: column;
            align-items: flex-start;

            .side-text {
              margin-top: 8px;
            }
          }
        }

        .cancel-subscription {
          margin-top: 24px;
        }
      }
    }
  }
</style>
